import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import store from './store/store';

const root = ReactDOM.createRoot(document.getElementById('root') as any);
root.render(
  <Provider store={store as any}>
    <App />
  </Provider>
);

serviceWorker.register();
